<form role="form" [formGroup]="supervisorForm">
<h1 mat-dialog-title>SUPERVISOR</h1>
<div mat-dialog-content>
  <p>{{data.title}}</p>
  <p>
    <mat-form-field appearance="outline">
      <mat-label>First Name</mat-label>
      <input matInput formControlName="firstname" placeholder="Enter first name">
    </mat-form-field>
  </p>
  <p>
    <mat-form-field appearance="outline">
      <mat-label>Last Name</mat-label>
      <input matInput formControlName="lastname" placeholder="Enter last name">
    </mat-form-field>
  </p>
  <p>
    <mat-form-field appearance="outline">
      <mat-label>Teacher Id</mat-label>
      <input matInput formControlName="teacherid" placeholder="Enter ID">
    </mat-form-field>
  </p>
  <p>
    <mat-form-field appearance="outline">
      <mat-label>Phone Number</mat-label>
      <input matInput formControlName="phone" placeholder="Enter phone number">
    </mat-form-field>
  </p>
  <p>
    <mat-form-field appearance="outline">
      <mat-label>Email </mat-label>
      <input matInput formControlName="email" placeholder="Enter Email Address">
    </mat-form-field>
  </p>
  
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Close</button>
  <button mat-button [mat-dialog-close]="data.email" cdkFocusInitial (click)="addSupervisor()">Save</button>
</div>
</form>